import * as React from 'react'
import { memo } from 'react'
const SvgLocation = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 14.884 19"
  >
    <path
      d="M7.447 9.1a1.56 1.56 0 0 0 1.154-.482 1.59 1.59 0 0 0 .477-1.159 1.56 1.56 0 0 0-.482-1.154 1.59 1.59 0 0 0-1.159-.477 1.56 1.56 0 0 0-1.154.482 1.59 1.59 0 0 0-.477 1.158 1.56 1.56 0 0 0 .482 1.154 1.59 1.59 0 0 0 1.159.478m0 9.9a32.9 32.9 0 0 1-5.561-6.161A9.7 9.7 0 0 1 0 7.66a7.52 7.52 0 0 1 2.14-5.466A7.1 7.1 0 0 1 7.44 0a7.1 7.1 0 0 1 5.3 2.194 7.52 7.52 0 0 1 2.14 5.466A9.7 9.7 0 0 1 13 12.839 32.9 32.9 0 0 1 7.442 19Z"
      data-name="location_on_FILL1_wght100_GRAD0_opsz24 (1)"
    />
  </svg>
)
const Memo = memo(SvgLocation)
export default Memo
